import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/** @jsx jsx */
import { Fragment } from 'react';
import { jsx } from '@emotion/core';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { useTheme } from '../../theme';
import { IconButton } from '../IconButton';
import { searchIconCSS, searchInputContainerCSS, searchInputCSS, searchInputIconCSS } from './styles';

var SearchComponent = function SearchComponent(props) {
  var onClick = props.onClick,
      placeholder = props.placeholder,
      label = props.label,
      value = props.value;
  var theme = useTheme();

  var onChange = function onChange() {
    // @ts-ignore
    onClick && onClick.apply(void 0, arguments);
  };

  var onInputClick = function onInputClick() {
    // @ts-ignore
    onClick && onClick.apply(void 0, arguments);
  };

  return jsx("div", {
    css: searchInputContainerCSS,
    role: "search"
  }, jsx("div", {
    css: searchInputIconCSS
  }, jsx(SearchIcon, {
    label: ""
  })), jsx("input", {
    css: searchInputCSS(theme),
    "aria-label": label,
    placeholder: placeholder,
    onChange: onChange,
    onClick: onInputClick,
    value: value
  }));
};

export var Search = function Search(props) {
  var placeholder = props.placeholder,
      tooltip = props.tooltip,
      label = props.label,
      value = props.value,
      iconButtonProps = _objectWithoutProperties(props, ["placeholder", "tooltip", "label", "value"]);

  return jsx(Fragment, null, jsx(SearchComponent, {
    onClick: iconButtonProps.onClick,
    placeholder: placeholder,
    label: label,
    value: value || ''
  }), jsx(IconButton, _extends({
    css: searchIconCSS,
    icon: jsx(SearchIcon, {
      label: label
    }),
    tooltip: tooltip
  }, iconButtonProps)));
};
export default Search;